// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.p-datatable.separate table {
  border-collapse: separate !important;
}
div .p-column-header-content {
  color: #9e9e9e;
}
.p-datatable-scrollable.p-datatable-responsive-scroll {
  height: 100%;
}
.p-datatable-scrollable.p-datatable-responsive-scroll .p-datatable-wrapper {
  height: calc(100% - 80px);
}
.p-datatable .p-datatable-thead > tr > th {
  border: none !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
